<template>
    <div class="containerLC">
        <h2 class="accordion-header tab-header">
            <div class=" d-flex justify-content-between align-items-center">
                <div>
                    <h4 style="color: #2D2D2D;">Preferences Settings</h4>
                    <h5 style="color: #888888;" class="mt-2">Edit language preferences as per your requirements</h5>
                </div>
            </div>
        </h2>
        <hr>
        <div class="tab-selector">
            <div v-for="tab in tabList" :key="tab.id" class="tab-wrapper">

                <button :class="['tab-btn', { active: selectedtab === tab.id }]" @click="handleButtonClick(tab)"
                    :style="{ cursor: isEditOpen ? 'not-allowed' : 'pointer' }">
                    {{ tab.name }}
                </button>
            </div>
        </div>
        <div v-if="lcData.length > 0">
            <!-- <div v-for="item in lcData" :key="item.Cadmid"> -->
            <!-- {{ item }} -->
            <div :id="'scheduleHeading'" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="table-responsive">
                                    <table class="table text-center">
                                        <thead style="background-color: #F1F0FF !important;">
                                            <tr>
                                                <th style="word-wrap: break-word; white-space: normal;">LCID</th>
                                                <th style="word-wrap: break-word; white-space: normal;">Parameter ID
                                                </th>
                                                <th>Range Text</th>
                                                <th style="word-wrap: break-word; white-space: normal;">
                                                    Comment</th>
                                                <th>MinVal</th>
                                                <th style="word-wrap: break-word; white-space: normal;">
                                                    MaxVal</th>
                                                <th style="word-wrap: break-word; white-space: normal;">
                                                    ColorCode</th>
                                                <!-- <th v-if="isEditOpen"
                                                    style="word-wrap: break-word; white-space: normal;">
                                                    Actions</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in sortedLcData" :key="item.lcid">
                                                <td style=" word-wrap: break-word; white-space: normal;">
                                                    <span>{{ item.lcid }}</span>
                                                    <!-- <input v-else v-model="item.id" :disabled="!superadmin()"
                              style="width:100%; border-radius: 5px;padding-left: 5%; height: 100%; min-height: 40px;" /> -->
                                                </td>
                                                <td>
                                                    <span>{{ item.parameterId }}</span>
                                                </td>
                                                <td>
                                                    <span>{{ item.rangeText }}</span>
                                                    <!-- <input type="text" v-else v-model="item.rangeText"
                                                            style="width:100%; border-radius: 5px; padding-left: 5%; height: 100%; min-height: 40px;" /> -->
                                                </td>
                                                <td style=" word-wrap: break-word; white-space: normal;">
                                                    <span v-if="!isEditOpen"
                                                        style="display: block; text-align: justify;">{{ item.comment
                                                        }}</span>
                                                    <!-- <input type="textarea" v-else v-model="item.comment"
                                                            style="border-radius: 5px; word-wrap: break-word; padding-left: 5%; height: 100%; min-height: 40px;" /> -->
                                                    <textarea v-else v-model="item.comment"
                                                        style="width: 80%; border-radius: 5px; word-wrap: break-word; padding-left: 5%; height: 100%; min-height: 40px;"></textarea>
                                                </td>
                                                <td>
                                                    <span v-if="!isEditOpen">{{ item.minVal }}</span>
                                                    <input type="number" v-else v-model="item.minVal"
                                                        style="width:100%; border-radius: 5px; padding-left: 5%; height: 100%; min-height: 40px;"
                                                        @input="handleInput($event.target.value, index)" />
                                                </td>
                                                <td>
                                                    <span v-if="!isEditOpen">{{ item.maxVal }}</span>
                                                    <input type="number" v-else v-model="item.maxVal"
                                                        style="width:100%; border-radius: 5px; padding-left: 5%; height: 100%; min-height: 40px;" />
                                                </td>
                                                <td>
                                                    <span v-if="!isEditOpen">{{ item.colorCode }}</span>
                                                    <input type="color" v-else v-model="item.colorCode"
                                                        aria-label="Select color"
                                                        style="width: 100%; height: 40px; border-radius: 5px; min-height: 40px;" />
                                                </td>

                                                <td v-if="isEditOpen">
                                                    <button @click="deleteTestPreferenceData(item.id)"
                                                        class="btn btn-primary"
                                                        style="background-color: #F1F0FF; margin-left: 5%; color:#7b68ee; font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"><span
                                                            class="mx-2">Delete</span><i
                                                            class="fa-solid fa-ban fa-lg"></i> </button>
                                                </td>
                                            </tr>
                                            <!-- <tr v-if="isAddOpen">
                                                <td style="word-wrap: break-word; white-space: normal;">
                                                    <span>N/A</span>
                                                </td>
                                                <td>
                                                    <span>4</span>
                                                </td>
                                                <td>
                                                    <input type="text" v-model="newRow.rangeText"
                                                        style="width:100%; border-radius: 5px; padding-left: 5%; height: 100%; min-height: 40px;" />
                                                </td>
                                                <td style="word-wrap: break-word; white-space: normal;">
                                                    <textarea v-model="newRow.comment"
                                                        style="width: 80%; border-radius: 5px; word-wrap: break-word; padding-left: 5%; height: 100%; min-height: 40px;"></textarea>
                                                </td>
                                                <td>
                                                    <input type="number" v-model.number="newRow.minVal"
                                                        style="width:100%; border-radius: 5px; padding-left: 5%; height: 100%; min-height: 40px;" />
                                                </td>
                                                <td>
                                                    <input type="number" v-model.number="newRow.maxVal"
                                                        style="width:100%; border-radius: 5px; padding-left: 5%; height: 100%; min-height: 40px;" />
                                                </td>
                                                <td>
                                                    <input type="color" v-model="newRow.colorCode"
                                                        aria-label="Select color"
                                                        style="width: 100%; height: 40px; border-radius: 5px; min-height: 40px;" />
                                                </td>
                                                <td>
                                                    <button @click="cancelAddRow" class="btn btn-secondary"
                                                        style="margin-left: 5%; margin: 5%; border-radius: 15px;">
                                                        <span class="mx-2">Cancel</span><i
                                                            class="fa-solid fa-ban fa-lg"></i>
                                                    </button>
                                                </td>
                                            </tr> -->
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td style="word-wrap: break-word; white-space: normal; float:end;">

                                                    <button v-if="isEditOpen" @click="cancelEdit(item)"
                                                        class="btn btn-primary"
                                                        style="background-color: #F1F0FF; margin-left: 5%; color:#7b68ee; font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"><span
                                                            class="mx-2">Cancel</span><i
                                                            class="fa-solid fa-ban fa-lg"></i> </button>
                                                    <!-- <button v-else @click="addNewRow(newRow)" class="btn btn-primary"
                                                        style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"><span
                                                            class="mx-2">Add</span><i
                                                            class="fa-regular fa-circle-check fa-lg"></i></button> -->

                                                </td>
                                                <td style="word-wrap: break-word; white-space: normal; float:end;">
                                                    <button v-if="!isEditOpen" @click="editItem()"
                                                        class="btn btn-primary"
                                                        style=" font-weight: 600; border: 2px solid #7b68ee; border-radius: 15px;"><span
                                                            class="mx-2">Edit</span><i
                                                            class="fa-regular fa-pen-to-square fa-lg"></i></button>
                                                    <button v-else @click="saveLCData()" class="btn btn-primary"
                                                        style="font-weight: 600; border: 2px solid #7b68ee; margin:5% ; border-radius: 15px;"><span
                                                            class="mx-2">Save</span><i
                                                            class="fa-regular fa-circle-check fa-lg"></i></button>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- </div> -->

        </div>

        <div class="mt-3 pb-3 text-center" v-else>
            You can generate the default weightages by clicking
            <button class="btn btn-primary" type="button" @click="GenerateDefaultLanguageCommentData"
                :disabled="!superadmin()">
                Generate Default Language Comment Data
            </button>
            button
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
import { superadmin } from "../../utils/helper";

export default {
    name: "TestPreferenceSettings",
    components: {

    },
    data() {
        return {
            routetestId: window.atob(this.$route.query.id),
            tabList: [
                { id: 4, name: "VnA" },
                { id: 1, name: "Vocab" },
                { id: 2, name: "Grammar" },
                { id: 3, name: "Compression" },
                { id: 18, name: "Pronunciation" },
                { id: 19, name: "Fluency" }
            ],
            selectedtab: 4,
            isEditOpen: false,
            lcData: [],
            originalLCData: [],
            isAddOpen: false,
            newRow: {
                rangeText: '',
                comment: '',
                minVal: null,
                maxVal: null,
                colorCode: '#000000'
            }
        }
    },
    computed: {
        sortedLcData() {
            return [...this.lcData].sort((a, b) => {
                const minA = a.minVal == null || isNaN(Number(a.minVal)) ? -Infinity : Number(a.minVal);
                const minB = b.minVal == null || isNaN(Number(b.minVal)) ? -Infinity : Number(b.minVal);
                return minA - minB; // Ascending sort by MinVal only
            });
        },
    },
    mounted() {
        this.GetLanguageCommentData(this.selectedtab);
    },
    methods: {
        ...mapActions([
            "getLanguageCommentData",
            "updateLanguageCommentData",
            "generateLanguageCommentData",
            "ShowWarningMessage"
        ]),
        superadmin,
        handleButtonClick(tab) {
            this.selectedtab = tab.id;
            switch (tab.id) {
                case 4:
                    this.GetLanguageCommentData(4);
                    break;
                case 1:
                    this.GetLanguageCommentData(1);
                    break;
                case 2:
                    this.GetLanguageCommentData(2);
                    break;
                case 3:
                    this.GetLanguageCommentData(3);
                    break;
                case 18:
                    this.GetLanguageCommentData(18);
                    break;
                case 19:
                    this.GetLanguageCommentData(19);
                    break;
            }
        },
        async GetLanguageCommentData(parameterId) {
            var response = await this.getLanguageCommentData({
                testId: this.routetestId,
                parameterId: parameterId
            })
            if (response.status) {
                this.lcData = response.object.data.sort((a, b) => Number(a.minVal) - Number(b.minVal));
            }
        },
        editItem() {
            this.isEditOpen = true;
            this.originalLCData = JSON.parse(JSON.stringify(this.lcData));
        },
        cancelEdit() {
            this.isEditOpen = false;
            this.lcData = JSON.parse(JSON.stringify(this.originalLCData));

        },
        async saveLCData() {
            this.isEditOpen = false;
            const hasChanges = this.hasChanges(this.originalLCData, this.lcData);
            if (!hasChanges) {
                this.ShowWarningMessage("No changes detected.")

                return;
            }
            if (this.validateRanges(this.sortedLcData)) {
                const response = await this.updateLanguageCommentData({
                    testId: this.routetestId,
                    data: this.sortedLcData
                });
                if (response.status) {
                    this.originalLCData = JSON.parse(JSON.stringify(this.sortedLcData));
                }
                else
                    this.lcData = JSON.parse(JSON.stringify(this.originalLCData));
            }
            else {
                this.lcData = JSON.parse(JSON.stringify(this.originalLCData));
            }

        },
        hasChanges(originalData, updatedData) {
            return originalData.some((original, index) => {
                const updated = updatedData[index];
                return (
                    original.lcid === updated.lcid &&
                    (
                        original.comment !== updated.comment ||
                        original.minVal !== updated.minVal ||
                        original.maxVal !== updated.maxVal ||
                        original.colorCode !== updated.colorCode
                    )
                );
            });
        },
        validateRanges(data) {
            if (data[0].minVal !== 0) {
                this.ShowWarningMessage("First row minVal must be 0.");
                return false
            }

            if (data[data.length - 1].maxVal !== 100) {
                this.ShowWarningMessage("Last row maxVal must be 100.");
                return false
            }

            for (let i = 0; i < data.length; i++) {
                const row = data[i];
                if (row.minVal > row.maxVal) {
                    this.ShowWarningMessage(`Row ${i + 1}: minVal (${row.minVal}) must not exceed maxVal (${row.maxVal}).`)
                    return false

                }
                if (i < data.length - 1) {
                    const nextRow = data[i + 1];
                    if (Math.abs(row.maxVal + 0.01 - nextRow.minVal) > 0.01) {
                        this.ShowWarningMessage(`Ranges not continuous: Row ${i + 1} maxVal (${row.maxVal}) + 0.1 does not equal Row ${i + 2} minVal (${nextRow.minVal}).`)
                        return false
                    }
                }
            }

            return true;
        },
        async GenerateDefaultLanguageCommentData() {
            var response = await this.generateLanguageCommentData({
                testId: this.routetestId,
                parameterId: this.selectedtab
            })
            if (response.status) {
                this.lcData = response.object.data.sort((a, b) => Number(a.minVal) - Number(b.minVal));
            }
        },
        // addNewRow() {
        //     if (!this.isEditOpen) return;
        //     //   if (this.isAddOpen) {
        //     //     this.ShowWarningMessage("Finish adding the current row before adding a new one.");
        //     //     return;
        //     //   }
        //     this.isAddOpen = true;
        //     // const newLCData = 
        //   if (!this.validateRanges(this.sortedLcData)) {
        //         this.ShowWarningMessage("Invalid ranges detected. Please ensure valid ranges before adding.");
        //         this.isAddOpen = false;
        //     }
        // },
        // cancelAddRow() {
        //   this.isAddOpen = false;
        //   this.newRow = { lcid: '', parameterId: 4, rangeText: '', comment: '', minVal: null, maxVal: null, colorCode: '#ffffff', isNew: true };
        // },
        // deleteRow(lcid) {
        //   if (!this.isEditOpen) return;
        //   const row = this.lcData.find(item => item.lcid === lcid);
        //   if (row) {
        //     this.deletedRows.push(lcid); // Mark for deletion
        //     this.lcData = this.lcData.filter(item => item.lcid !== lcid);
        //   }
        // },
        // toggleActive(item) {
        //     if (!this.superadmin() || !item.isEditing) return;
        //     item.isActive = !item.isActive; 
        // },
    }
}
</script>
<style>
.containerLC {
    background: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    width: 100%;
}

.tab-header {
    margin: 24px;
    padding: 24px 0 6px 0;
}

hr {
    border-bottom: 1px solid gray;
}

.tab-selector {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    background-color: #f1f0ff;
    margin: 24px;
    padding: 8px 16px;
    border-radius: 5px;
    width: fit-content;
}

.tab-wrapper {
    flex: 1;
    text-align: center;
}

.tab-btn {
    padding: 5px 16px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    background-color: #f1f0ff;
}

.tab-btn:hover {
    background-color: #4B2EEE;
    border-radius: 5px;
    color: white;
}

.tab-btn.active {
    background-color: #4B2EEE;
    border-radius: 5px;
    color: white;
}

.tab-btn.notactive {
    background-color: #4B2EEE;
    border-radius: 5px;
    color: white;
}

@media (min-width: 1281px) {
    .languageContainer {
        width: 85vw;
    }

    .addDeleteBtn {
        width: 17vw;
        margin-left: 0px;
    }
}

@media ((min-width: 990px) and (max-width:1281px)) {
    .languageContainer {
        width: 71vw !important;
    }

    .addDeleteBtn {
        width: 24vw;
        margin-left: 0px;
    }
}

@media (max-width: 990px) {
    .language-selector {
        flex-wrap: wrap;
    }

    .addDeleteBtn {
        margin-left: 24px;
        margin-bottom: 0;
    }

    .section-header {
        height: auto;
    }

    .section-actions {
        justify-content: flex-start;
    }
}
</style>